/*
  Hard coded until Trade History REST provides an API
*/
const transactionCodes = [
  "B",
  "BCALL",
  "BCOV",
  "BCPIR",
  "BXS",
  "CADJR",
  "CADJREXT",
  "CADJW",
  "CADJWEXT",
  "CBXS",
  "CDEP",
  "CDFG",
  "CLTW",
  "CSXS",
  "CTFP",
  "CWFL",
  "FFXB",
  "FFXS",
  "FXB",
  "FXS",
  "IADJ",
  "IR",
  "MAT",
  "MBCALL",
  "MGFP",
  "MSCEP",
  "RED",
  "RP",
  "RPDIR",
  "S",
  "SDO",
  "SHS",
  "SRI",
  "SUB",
  "SXS",
  "TSDO",
  "TSRI",
  "XSDO",
  "XSRI"
];
export const txColumnDef = [
  {
    headerName: "Transaction Code",
    field: "transcationCode",
    suppressSizeToFit: false,
  },
];

export default transactionCodes;
